import React, {
  useState,
  useEffect,
  useRef,
  MouseEventHandler,
  useMemo,
} from "react";
import styled from "styled-components";
import { CiSearch } from "react-icons/ci";
import Modal from "react-modal";
import {
  FaFire,
  FaWalking,
  FaHeart,
  FaRoute,
  FaEdit,
  FaTrash,
  FaComment,
  FaDownload,
} from "react-icons/fa";
import { IoLocation } from "react-icons/io5";
import { MdAssignmentInd } from "react-icons/md";
import { IoEllipsisVertical } from "react-icons/io5";
import threadmill from "../assets/threadmill.png";
import jogging from "../assets/jogging.png";
import MaleAvatar17 from "../assets/User.png";
import { getImageFromCache, saveImageToCache } from "../utils/Imagecacheutils";
import axios from "axios";
import {
  fetchChallenges,
  deleteChallenges,
  fetchGroups,
  fetchGroupMap,
  assignChallenges,
  getAssignedChallenges,
  useCheckSessionHeartBeat,
} from "components/API/ApiEnpoints";
import { convertUTCToLocal } from "components/utils/DateUtils";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "components/utils/ConfirmationDialog";
import openNotification from "components/utils/CustomNotification";
import { formatDateRange, formatDate } from "components/utils/DateUtils";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import SkeletonLoader from "components/Loaders/SkeletonLoader";
import { withUIDirectives } from "components/utils/UI_Directive/showUIDirectives";
import HistoryModal from "../utils/HistoryModal"; // Kept from original
import { FaHistory } from "react-icons/fa"; // Kept from original
import { SlFire } from "react-icons/sl";
import { IoFootsteps } from "react-icons/io5";
import { FaMapMarkerAlt } from "react-icons/fa";
import { RiArrowDropDownLine } from "react-icons/ri";

Modal.setAppElement("#root");

interface PrizeDistribution {
  positions: string;
  amount: string;
  reward_type: string;
}

interface PrizePool {
  total_amounts: string;
  distributions: PrizeDistribution[];
}

export interface Challenge {
  org_uid: string;
  user_uid: string;
  challenge_uid: string;
  challenge_name: string;
  challenge_desc: string;
  challenge_type: string;
  metric_type: string;
  from_datetime: string;
  to_datetime: string;
  end_datetime: string;
  visibility: string;
  goal_count: number;
  goal_evaluation_mode?: string;
  max_participants: string;
  challenge_status: string;
  last_registration_date: string;
  prize_pool: PrizePool;
  members_joined: number;
  image: string;
  joined?: boolean;
  join?: boolean;
  rejoin?: boolean;
  cachedImageUrl?: string;
  image_uid?: string;
  image_timestamp?: string;
  imageSource?: string;
  history_uid?: string; // Kept from original
}

export interface HomepageChallenge extends Challenge {
  start_datetime: string;
  end_datetime: string;
  group_uid: string;
  user_uid: string;
  join?: boolean;
  rejoin?: boolean;
}

interface TeamRecord {
  org_uid: string;
  group_uid: string;
  group_name: string;
  group_type: string;
  description: string;
  code: null;
  status: string;
  reason: string;
  source: string;
  created_at: string;
  created_by: string;
  update_history: string;
  users_count: number;
  active_users: number;
}

export const ChallangeIcon = (challange: string) => {
  switch (challange) {
    case "steps":
      return <IoFootsteps />;
    case "distance":
      return <FaMapMarkerAlt />;
    case "caloriesburned":
      return <SlFire />;
    default:
      return null;
  }
};

export const ChallangeText = (challange: string) => {
  switch (challange) {
    case "steps":
      return "Steps";
    case "distance":
      return "Distance";
    case "caloriesburned":
      return "Calories burned";
    default:
      return null;
  }
};

const ChallangesPage = () => {
  useCheckSessionHeartBeat();
  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
  const [loadingAssignedChallenges, setLoadingAssignedChallenges] =
    useState(false);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Ongoing");
  const [challengesData, setChallengesData] = useState<Challenge[]>([]);
  const [assignedChallenges, setAssignedChallenges] = useState<
    HomepageChallenge[]
  >([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [challengeRecord, setChallengeRecord] = useState<Challenge | {}>({});
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";
  const [isDropdownVisible, setIsDropdownVisible] = useState<string | null>(
    null,
  );
  const [assignIndividual, setAssignIndividual] = useState<
    { value: string; label: string; image: string; role: string }[]
  >([]);
  const [selectedTeam, setSelectedTeam] = useState<TeamRecord[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<"individual" | "team">(
    "individual",
  );
  const isIndividualMode = modalType === "individual";
  const [teamRecords, setTeamRecords] = useState<TeamRecord[]>([]);
  const [selectedChallengeUid, setSelectedChallengeUid] = useState<
    string | null
  >(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [viewMode, setViewMode] = useState<"all" | "my">("my");
  const privilege = localStorage.getItem("privilege") || "";
  const user_role = localStorage.getItem("user_role") || "";
  const isOrgAdmin = privilege === "orgadmin";
  const [mappedMembers, setMappedMembers] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<"available" | "mapped">(
    "available",
  );
  const [expandedTeamUid, setExpandedTeamUid] = useState<string | null>(null);
  const [teamMembersForGroup, setTeamMembersForGroup] = useState<
    Record<string, any[]>
  >({});
  const [allUsers, setAllUsers] = useState<any[]>([]);
  const [showDeleteSelect, setShowDeleteSelect] = useState(false);
  const [selectedToDelete, setSelectedToDelete] = useState<any[]>([]);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedChallengeToQuit, setSelectedChallengeToQuit] =
    useState<HomepageChallenge | null>(null);
  const [showMenuForChallenge, setShowMenuForChallenge] = useState<
    string | null
  >(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewModalChallenge, setViewModalChallenge] = useState<
    Challenge | HomepageChallenge | null
  >(null);
  const [menuClicked, setMenuClicked] = useState(false);
  const [loadingChallenges, setLoadingChallenges] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showQuitModal, setShowQuitModal] = useState(false);
  const [quitReason, setQuitReason] = useState("");
  const [isQuitting, setIsQuitting] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<FilterKey>("3m");

  // Logic specific to original file (Restored)
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyUid, setHistoryUid] = useState<string | null>(null);
  const [selectedMappedItems, setSelectedMappedItems] = useState<any[]>([]);

  const getChallengeStatusValue = (tab: string) => {
    switch (tab) {
      case "Upcoming":
        return "inactive";
      case "Ongoing":
        return "active";
      case "Ended":
        return "completed";
      default:
        return "inactive";
    }
  };

  const getChallengeStartDate = (challenge: Challenge | HomepageChallenge) => {
    return (
      (challenge as HomepageChallenge).start_datetime || challenge.from_datetime
    );
  };

  const getChallengeEndDate = (challenge: Challenge | HomepageChallenge) => {
    return (
      (challenge as HomepageChallenge).end_datetime || challenge.to_datetime
    );
  };

  const getFriendlyErrorMessage = (rawMessage: any) => {
    const message =
      typeof rawMessage === "string" ? rawMessage.toLowerCase() : "";

    if (message.includes("invalid user")) {
      return "Access Denied: You don't have permission to view challenges.";
    }

    if (message.includes("failed")) {
      return "Unable to load challenges at the moment. Please try again later.";
    }

    return typeof rawMessage === "string"
      ? rawMessage
      : "Something went wrong while fetching challenges.";
  };

  const filteredUsers = useMemo(() => {
    if (!searchTerm.trim()) {
      return allUsers;
    }

    return allUsers.filter(
      (user) =>
        user.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.email &&
          user.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (user.department &&
          user.department.toLowerCase().includes(searchTerm.toLowerCase())),
    );
  }, [allUsers, searchTerm]);

  const fetchImagesByUid = async (
    imageUids: string[],
  ): Promise<Record<string, { image: string; timestamp: string }>> => {
    if (!imageUids || imageUids.length === 0) {
      return {};
    }

    try {
      const url = new URL(`${beAddress}/api/get-image-by-uid`);
      imageUids.forEach((uid) =>
        url.searchParams.append("image_uid_list", uid),
      );
      url.searchParams.set("is_icon_img", "false");
      url.searchParams.set("is_feedback_image", "false");

      const res = await fetch(url.toString(), {
        headers: {
          "user-uid": userUid,
        },
        credentials: "include",
      });
      const data = await res.json();

      if (data.status === "Success" && Array.isArray(data.data)) {
        return Object.fromEntries(
          data.data.map((item: any) => {
            if (item.default)
              return [item.image_uid, { image: "", timestamp: "" }];
            return [
              item.image_uid,
              { image: item.image, timestamp: item.timstamp },
            ];
          }),
        );
      }
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }

    return {};
  };

  function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  }

  const getChallangesData = async (
    filterKey: FilterKey = selectedFilter as FilterKey,
  ) => {
    setLoadingChallenges(true);
    const params = applyFilterParams(filterKey);
    const apiResponse = await fetchChallenges(sessionUid, userUid, params);
    if (apiResponse.status === "Success") {
      let allChallenges = Array.isArray(apiResponse.data)
        ? apiResponse.data
        : [];

      // Image caching logic
      const cacheCheckPromises = allChallenges.map(async (ch: any) => {
        const imageUid = ch.image_details?.image_uid;
        const imageTimestamp = ch.image_details?.timestamp || "";

        if (!imageUid) return { ...ch, needsFetch: false, imageUid: null };
        const cachedUrl = await getImageFromCache(imageUid, imageTimestamp);

        return {
          ...ch,
          imageUid,
          imageTimestamp,
          cachedUrl,
          needsFetch: !cachedUrl,
        };
      });
      const cacheChecked = await Promise.all(cacheCheckPromises);

      const imageUidsToFetch = cacheChecked
        .filter((ch) => ch.needsFetch)
        .map((ch) => ch.imageUid)
        .filter(Boolean);

      let fetchedImages: Record<string, { image: string; timestamp: string }> =
        {};
      if (imageUidsToFetch.length > 0) {
        try {
          fetchedImages = await fetchImagesByUid(imageUidsToFetch);
        } catch (err) {
          console.error("Image fetch failed:", err);
        }
      }

      allChallenges = await Promise.all(
        cacheChecked.map(async (challenge: any) => {
          const { imageUid, imageTimestamp, cachedUrl, needsFetch } = challenge;

          if (!imageUid) {
            return {
              ...challenge,
              image: threadmill,
              cachedImageUrl: null,
              image_uid: null,
              image_timestamp: null,
              imageSource: "default-no-uid",
            };
          }

          if (cachedUrl) {
            return {
              ...challenge,
              image: cachedUrl,
              cachedImageUrl: cachedUrl,
              image_uid: imageUid,
              image_timestamp: imageTimestamp,
              imageSource: "cache",
            };
          }

          const fetchedImageData = fetchedImages[imageUid];
          if (fetchedImageData && fetchedImageData.image) {
            await saveImageToCache(
              imageUid,
              imageUid,
              fetchedImageData.image,
              fetchedImageData.timestamp,
            );

            const newUrl = await getImageFromCache(
              imageUid,
              fetchedImageData.timestamp,
            );
            return {
              ...challenge,
              image: newUrl || threadmill,
              cachedImageUrl: newUrl,
              image_uid: imageUid,
              image_timestamp: fetchedImageData.timestamp,
              imageSource: "api-fresh",
            };
          }

          return {
            ...challenge,
            image: threadmill,
            cachedImageUrl: null,
            image_uid: imageUid,
            image_timestamp: imageTimestamp,
            imageSource: "default-fallback",
          };
        }),
      );

      const updatedChallenges = allChallenges.map((ch: Challenge) => ({
        ...ch,
        cachedImageUrl: ch.cachedImageUrl || "",
      }));
      const joinedChallenges = updatedChallenges.filter(
        (ch: Challenge) => ch.joined === true,
      );
      setAssignedChallenges(joinedChallenges);
      setChallengesData(updatedChallenges);
    } else {
      setChallengesData([]);
      setAssignedChallenges([]);
      openNotification({
        type: "error",
        message: getFriendlyErrorMessage(apiResponse.data),
      });
    }

    setLoadingChallenges(false);
  };

  const fetchChallengeMappings = async (challenge: Challenge) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/challenges-maping`,
        {
          params: {
            challenge_uid: challenge.challenge_uid,
          },
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
        },
      );
      const responseData = withUIDirectives(response.data);
      if (responseData?.status === "Success") {
        setMappedMembers(responseData.data || []);
      } else {
        openNotification({
          type: "error",
          message: responseData?.message || "Failed to fetch mappings",
        });
      }
    } catch (error) {
      console.error("Mapping Fetch Error:", error);
      openNotification({
        type: "error",
        message: "Error fetching challenge mappings",
      });
    }
  };

  const fetchAssignedChallenges = async (
    sessionUid: string,
    userUid: string,
  ) => {
    const headers = {
      accept: "application/json",
      "user-uid": userUid,
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/assigned-challenges`,
        {
          headers,
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      openNotification({ type: "error", message: "Assignment successful" });
      return { status: "Error", data: [] };
    }
  };

  // Logic from Original challenges.txt (Robust Payload)
  // Updated handleAssignChallenge function
  const handleAssignChallenge = async () => {
    try {
      // Get the challenge from challengesData using selectedChallengeUid
      const challenge = challengesData.find(
        (c) => c.challenge_uid === selectedChallengeUid,
      );

      // Fallback: if not found in challengesData, try to get it from the current modal state
      if (!challenge && selectedChallengeUid) {
        // You might need to track the current challenge being assigned
        // For now, let's get it from a safer source
        const currentChallenge =
          viewModalChallenge ||
          challengesData.find((c) => c.challenge_uid === selectedChallengeUid);

        if (!currentChallenge) {
          openNotification({
            type: "error",
            message: "Challenge not found. Please refresh and try again.",
          });
          return;
        }
      }

      const orgUid = challenge?.org_uid || "";
      const challengeUid = selectedChallengeUid || challenge?.challenge_uid;

      // Validate that we have a challenge_uid
      if (!challengeUid) {
        openNotification({
          type: "error",
          message: "Challenge UID is missing. Cannot assign.",
        });
        return;
      }

      let payload;

      if (modalType === "individual") {
        const user_uid_list = assignIndividual.map((u) => u.value);
        payload = {
          org_uid: orgUid,
          challenge_uid: challengeUid, // Use the validated challengeUid
          user_uid_list,
        };
      } else if (modalType === "team") {
        const group_uid_list = selectedTeam.map((t) => t.group_uid);
        payload = {
          org_uid: orgUid,
          challenge_uid: challengeUid, // Use the validated challengeUid
          group_uid_list,
        };
      }

      // Debug log to see what's being sent
      console.log("Assign payload:", payload);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/challenges-maping`,
        payload,
        {
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
        },
      );

      const responseData = withUIDirectives(response.data);

      if (responseData?.status === "Success") {
        openNotification({ type: "success", message: "Assignment successful" });
        window.location.reload();
        // Refresh the mappings
        if (selectedChallengeUid) {
          const challengeToRefresh = challengesData.find(
            (c) => c.challenge_uid === selectedChallengeUid,
          );
          if (challengeToRefresh) {
            await fetchChallengeMappings(challengeToRefresh);
          }
        }
        setAssignIndividual([]);
        setSelectedTeam([]);
        setSearchTerm("");
        setActiveTab("mapped"); // Keep this if you want to show mapped tab after success

        // Close the modal
        setIsModalOpen(false);
      } else {
        openNotification({
          type: "error",
          message: responseData?.message || "Assignment failed",
        });
      }
    } catch (err: any) {
      console.error("Assign Error:", err);

      // More detailed error logging
      if (err.response) {
        console.error("Response error:", err.response.data);
        console.error("Response status:", err.response.status);
      }

      openNotification({
        type: "error",
        message:
          err.response?.data?.message ||
          "Server error during assignment. Please check the payload.",
      });
    }

    setIsModalOpen(false);
  };

  const getAllUsers = async () => {
    try {
      if (!selectedChallengeUid) {
        console.error("No challenge selected");
        openNotification({
          type: "error",
          message: "No challenge selected",
        });
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/challenge-participants`,
        {
          params: {
            challenge_uid: selectedChallengeUid,
          },
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
        },
      );

      const data = withUIDirectives(response.data);
      const users = data?.data || [];

      // Filter users with assign: true
      const assignableUsers = users.filter((user: any) => user.assign === true);

      const userOptions = assignableUsers.map((user: any) => ({
        value: user.user_uid,
        label: user.user_name,
        image: user.profile_url || MaleAvatar17,
        desig: user.user_role || "Member",
        email: user.email || "",
        department: user.job_title || "",
        assign: user.assign || false,
        reassign: user.reassign || false,
      }));

      setAllUsers(userOptions);
    } catch (err) {
      console.error("Error fetching users:", err);
      openNotification({
        type: "error",
        message: "Failed to fetch users for this challenge",
      });
    }
  };

  const handleJoinChallenge = async (challenge: Challenge) => {
    const payload = {
      challenge_uid: challenge.challenge_uid,
      user_uid: userUid,
      org_uid: challenge.org_uid,
      is_rejoin: challenge.rejoin === true,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/join-challenge`,
        payload,
        {
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
        },
      );

      const responseData = withUIDirectives(response.data);
      if (responseData?.status === "Success") {
        openNotification({
          type: "success",
          message: "Successfully joined challenge!",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        await getChallangesData();
      } else {
        openNotification({
          type: "error",
          message: responseData?.data || "Failed to join challenge.",
        });
      }
    } catch (err) {
      openNotification({
        type: "error",
        message: "An error occurred while joining the challenge.",
      });
      console.error("Join API Error:", err);
    }
  };

  const handleQuitChallenge = async () => {
    if (!selectedChallengeToQuit || !quitReason.trim()) {
      openNotification({
        type: "warning",
        message: "Please provide a reason for quitting.",
      });
      return;
    }

    setIsQuitting(true);

    const payload = {
      challenge_uid: selectedChallengeToQuit.challenge_uid,
      org_uid: selectedChallengeToQuit.org_uid,
      user_uid: userUid,
      start_datetime:
        selectedChallengeToQuit.start_datetime ||
        selectedChallengeToQuit.from_datetime,
      reason: quitReason.trim(),
    };
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/quit-challenge`,
        {
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
          data: payload,
        },
      );
      if (response.data?.status === "Success") {
        openNotification({
          type: "success",
          message: "Successfully quit the challenge.",
        });
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
        setShowQuitModal(false);
        setQuitReason("");
        setSelectedChallengeToQuit(null);
        handleAssignedChallenges();
      } else {
        openNotification({
          type: "error",
          message: response.data?.message || "Failed to quit challenge.",
        });
      }
    } catch (err) {
      openNotification({
        type: "error",
        message: "An error occurred while quitting the challenge.",
      });
      console.error("Quit API Error:", err);
    } finally {
      setIsQuitting(false);
    }
  };

  const getGroups = async () => {
    try {
      // Get challenge info to get org_uid
      const challenge = challengesData.find(
        (c) => c.challenge_uid === selectedChallengeUid,
      );
      const orgUid = challenge?.org_uid || "";
      console.log("Assign payload challenge_uid---:", selectedChallengeUid);

      // First, get assignable groups from challenge-participants
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/challenge-participants`,
        {
          params: {
            challenge_uid: selectedChallengeUid,
          },
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
        },
      );

      const data = withUIDirectives(response.data);
      const participants = data?.data || [];

      // Filter groups that are assignable (assign: true) and have group_type
      const assignableGroups = participants.filter(
        (item: any) => item.assign === true && item.group_uid,
      );

      // Now fetch detailed group information including member counts from groups API
      try {
        const groupsResponseRaw = await fetchGroups(sessionUid, userUid, {
          org_uid: orgUid,
        });
        const groupsResponse = withUIDirectives(groupsResponseRaw);

        if (groupsResponse?.status === "Success") {
          const allGroups = groupsResponse.data || [];

          // Create a map of group_uid to group details for quick lookup
          const groupDetailsMap = new Map();
          allGroups.forEach((group: any) => {
            groupDetailsMap.set(group.group_uid, {
              users_count: group.users_count || 0,
              active_users: group.active_users || 0,
              group_name: group.group_name,
              group_type: group.group_type,
              org_uid: group.org_uid,
            });
          });

          // Format into TeamRecord structure with member counts
          const teamOptions: TeamRecord[] = assignableGroups.map(
            (group: any) => {
              const groupDetails = groupDetailsMap.get(group.group_uid) || {};

              return {
                org_uid: groupDetails.org_uid || orgUid,
                group_uid: group.group_uid,
                group_name:
                  group.group_name ||
                  groupDetails.group_name ||
                  "Unknown Group",
                group_type:
                  group.group_type || groupDetails.group_type || "projectteam",
                description: group.description || "",
                code: group.code || null,
                status: group.status || "active",
                reason: group.reason || "",
                source: group.source || "",
                created_at: group.created_at || "",
                created_by: group.created_by || "",
                update_history: group.update_history || "",
                users_count: groupDetails.users_count || 0,
                active_users: groupDetails.active_users || 0,
              };
            },
          );

          setTeamRecords(teamOptions);
        } else {
          // If groups API fails, use basic info from challenge-participants
          const teamOptions: TeamRecord[] = assignableGroups.map(
            (group: any) => ({
              org_uid: orgUid,
              group_uid: group.group_uid,
              group_name: group.group_name,
              group_type: group.group_type || "projectteam",
              description: "",
              code: null,
              status: "active",
              reason: "",
              source: "",
              created_at: "",
              created_by: "",
              update_history: "",
              users_count: 0, // Will show as "0 members"
              active_users: 0,
            }),
          );

          setTeamRecords(teamOptions);
        }
      } catch (groupError) {
        console.error("Error fetching group details:", groupError);

        // Fallback to basic info if groups API fails
        const teamOptions: TeamRecord[] = assignableGroups.map(
          (group: any) => ({
            org_uid: orgUid,
            group_uid: group.group_uid,
            group_name: group.group_name,
            group_type: group.group_type || "projectteam",
            description: "",
            code: null,
            status: "active",
            reason: "",
            source: "",
            created_at: "",
            created_by: "",
            update_history: "",
            users_count: 0,
            active_users: 0,
          }),
        );

        setTeamRecords(teamOptions);
      }
    } catch (error) {
      console.error("Error in getGroups:", error);
      setTeamRecords([]);
      openNotification({
        type: "error",
        message: "Failed to fetch participants for this challenge",
      });
    }
  };

  // Logic from Original challenges.txt (Robust Deletion)
  const handleDeleteMapping = async () => {
    try {
      const challenge = challengesData.find(
        (c) => c.challenge_uid === selectedChallengeUid,
      );
      const orgUid = challenge?.org_uid || selectedMappedItems[0]?.org_uid;

      let payload;

      if (modalType === "team") {
        const group_uid_list = selectedMappedItems.map(
          (item) => item.group_uid,
        );
        payload = {
          org_uid: orgUid,
          challenge_uid: selectedChallengeUid,
          group_uid_list,
        };
      } else {
        const user_uid_list = selectedMappedItems.map((item) => item.user_uid);
        payload = {
          org_uid: orgUid,
          challenge_uid: selectedChallengeUid,
          user_uid_list,
        };
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/challenges-maping`,
        {
          headers: {
            accept: "application/json",
            "user-uid": userUid,
          },
          withCredentials: true,
          data: payload,
        },
      );
      if (response.data?.status === "Success") {
        openNotification({
          type: "success",
          message: `${selectedMappedItems.length} ${
            modalType === "team" ? "team" : "user"
          } removed successfully`,
        });
        window.location.reload();
        setMappedMembers((prev) => {
          if (modalType === "team") {
            return prev.filter(
              (member) =>
                !selectedMappedItems.some(
                  (item) => item.group_uid === member.group_uid,
                ),
            );
          } else {
            return prev
              .map((member) => {
                if (member.user_list) {
                  const filteredUsers = member.user_list.filter(
                    (user: any) =>
                      !selectedMappedItems.some(
                        (item) => item.user_uid === user.user_uid,
                      ),
                  );
                  return { ...member, user_list: filteredUsers };
                }
                return member;
              })
              .filter((member) => member.user_list?.length > 0);
          }
        });
        setSelectedMappedItems([]);
        setShowDeleteSelect(false);
        setShowDeleteConfirmModal(false);
      } else {
        openNotification({
          type: "error",
          message: response.data?.message || "Failed to remove mappings",
        });
      }
    } catch (err) {
      console.error("Mapping Delete Error:", err);
      openNotification({
        type: "error",
        message: "Error occurred while deleting mappings",
      });
    }
  };

  useEffect(() => {
    getChallangesData();
  }, []);

  useEffect(() => {
    if (modalType === "team") {
      getGroups();
    }
  }, [modalType]);

  useEffect(() => {
    if (isModalOpen) {
      setSearchTerm("");
      setAssignIndividual([]); // Reset when opening
      setSelectedTeam([]); // Reset when opening
      setShowDeleteSelect(false);
      setSelectedMappedItems([]);
      setActiveTab("available");
    }
  }, [modalType, isModalOpen]);

  const filteredTeamRecords = useMemo(() => {
    if (!searchTerm.trim() || !teamRecords.length) {
      return teamRecords;
    }

    const searchLower = searchTerm.toLowerCase();

    return teamRecords.filter((team) =>
      team.group_name.toLowerCase().includes(searchLower),
    );
  }, [teamRecords, searchTerm]);

  // const toggleDropdown = (challangeUid: string) => {
  //   setIsDropdownVisible(
  //     isDropdownVisible === challangeUid ? null : challangeUid,
  //   );
  //   setSelectedChallengeUid(
  //     selectedChallengeUid === challangeUid ? null : challangeUid,
  //   );
  // };
  const toggleDropdown = (challengeUid: string) => {
    setIsDropdownVisible(
      isDropdownVisible === challengeUid ? null : challengeUid,
    );
    // Always set the selectedChallengeUid when opening dropdown
    setSelectedChallengeUid(challengeUid);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Optionally: Clear selections when search changes?
    // setAssignIndividual([]);
    // setSelectedTeam([]);
  };

  const getChallengeImageUrl = (imageDetails: any) => {
    if (!imageDetails?.image_uid) return "fallback.png";
    return `${process.env.REACT_APP_API_URL}/api/files/${imageDetails.image_uid}`;
  };

  const formatDateForDisplayUI = (dateInput: Date | string): string => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

    const datePart = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    const timePart = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${datePart} ${timePart}`;
  };
  const getDisplayFromDate = (tab: string = selectedTab): Date => {
    const today = new Date();
    const fromDate = new Date(today);

    switch (selectedFilter) {
      case "1m":
        if (tab === "Ended") {
          fromDate.setMonth(today.getMonth() - 1);
        } else if (tab === "Upcoming") {
          fromDate.setMonth(today.getMonth());
        } else {
          // Ongoing
          fromDate.setMonth(today.getMonth() - 1);
        }
        break;

      case "3m":
        if (tab === "Ended") {
          fromDate.setMonth(today.getMonth() - 3);
        } else if (tab === "Upcoming") {
          fromDate.setMonth(today.getMonth());
        } else {
          // Ongoing
          fromDate.setMonth(today.getMonth() - 3);
        }
        break;

      case "6m":
        if (tab === "Ended") {
          fromDate.setMonth(today.getMonth() - 6);
        } else if (tab === "Upcoming") {
          fromDate.setMonth(today.getMonth());
        } else {
          // Ongoing
          fromDate.setMonth(today.getMonth() - 6);
        }
        break;

      case "1y":
        if (tab === "Ended") {
          fromDate.setFullYear(today.getFullYear() - 1);
        } else if (tab === "Upcoming") {
          fromDate.setFullYear(today.getFullYear());
        } else {
          // Ongoing
          fromDate.setFullYear(today.getFullYear() - 1);
        }
        break;

      case "all":
        if (tab === "Ended") {
          fromDate.setFullYear(2020);
        } else if (tab === "Upcoming") {
          fromDate.setFullYear(today.getFullYear());
        } else {
          // Ongoing
          fromDate.setFullYear(2020);
        }
        break;

      default:
        fromDate.setMonth(today.getMonth() - 3);
    }

    return fromDate;
  };

  const getDisplayToDate = (tab: string = selectedTab): Date => {
    const today = new Date();
    const toDate = new Date(today);

    switch (selectedFilter) {
      case "1m":
        if (tab === "Ended") {
          toDate.setMonth(today.getMonth());
        } else if (tab === "Upcoming") {
          toDate.setMonth(today.getMonth() + 1);
        } else {
          // Ongoing
          toDate.setMonth(today.getMonth() + 1);
        }
        break;

      case "3m":
        if (tab === "Ended") {
          toDate.setMonth(today.getMonth());
        } else if (tab === "Upcoming") {
          toDate.setMonth(today.getMonth() + 3);
        } else {
          // Ongoing
          toDate.setMonth(today.getMonth() + 3);
        }
        break;

      case "6m":
        if (tab === "Ended") {
          toDate.setMonth(today.getMonth());
        } else if (tab === "Upcoming") {
          toDate.setMonth(today.getMonth() + 6);
        } else {
          // Ongoing
          toDate.setMonth(today.getMonth() + 6);
        }
        break;

      case "1y":
        if (tab === "Ended") {
          toDate.setFullYear(today.getFullYear());
        } else if (tab === "Upcoming") {
          toDate.setFullYear(today.getFullYear() + 1);
        } else {
          // Ongoing
          toDate.setFullYear(today.getFullYear() + 1);
        }
        break;

      case "all":
        if (tab === "Ended") {
          toDate.setFullYear(today.getFullYear());
        } else if (tab === "Upcoming") {
          toDate.setFullYear(today.getFullYear() + 1);
        } else {
          // Ongoing
          toDate.setFullYear(today.getFullYear() + 1);
        }
        break;

      default:
        toDate.setMonth(today.getMonth() + 3);
    }

    return toDate;
  };
  const getDisplayFromDateFromAPI = (): Date => {
    const params = applyFilterParams(selectedFilter);
    if (params.from_datetime) {
      // Parse the API format back to Date
      const [year, month, day, hour, minute] =
        params.from_datetime
          .match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z/)
          ?.slice(1, 6)
          .map(Number) || [];

      if (year && month && day && hour !== undefined && minute !== undefined) {
        return new Date(Date.UTC(year, month - 1, day, hour, minute));
      }
    }

    // Fallback to calculation
    return getDisplayFromDate();
  };

  const getDisplayToDateFromAPI = (): Date => {
    const params = applyFilterParams(selectedFilter);
    if (params.to_datetime) {
      // Parse the API format back to Date
      const [year, month, day, hour, minute] =
        params.to_datetime
          .match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z/)
          ?.slice(1, 6)
          .map(Number) || [];

      if (year && month && day && hour !== undefined && minute !== undefined) {
        return new Date(Date.UTC(year, month - 1, day, hour, minute));
      }
    }

    // Fallback to calculation
    return getDisplayToDate();
  };

  const handleAssignedChallenges = async (
    filterKey: FilterKey = selectedFilter as FilterKey,
  ) => {
    setLoadingAssignedChallenges(true);

    try {
      // Apply filter parameters for assigned challenges
      const params = applyFilterParams(filterKey);

      // Build the API URL with query parameters
      let apiUrl = `${process.env.REACT_APP_API_URL}/api/assigned-challenges`;

      // Add filter parameters if they exist
      if (params.from_datetime || params.to_datetime) {
        const queryParams = new URLSearchParams();
        if (params.from_datetime) {
          queryParams.append("from_datetime", params.from_datetime);
        }
        if (params.to_datetime) {
          queryParams.append("to_datetime", params.to_datetime);
        }
        apiUrl += `?${queryParams.toString()}`;
      }

      const response = await axios.get(apiUrl, {
        headers: {
          accept: "application/json",
          "user-uid": userUid,
        },
        withCredentials: true,
      });

      const data = response.data;

      if (data.status === "Success") {
        let assigned = Array.isArray(data.data) ? data.data : [];

        // Image caching logic (keep existing)
        const cacheCheckPromises = assigned.map(async (ch: any) => {
          const imageUid = ch.image_details?.image_uid;
          const imageTimestamp = ch.image_details?.timestamp || "";

          if (!imageUid) return { ...ch, needsFetch: false, imageUid: null };
          const cachedUrl = await getImageFromCache(imageUid, imageTimestamp);

          return {
            ...ch,
            imageUid,
            imageTimestamp,
            cachedUrl,
            needsFetch: !cachedUrl,
          };
        });
        const cacheChecked = await Promise.all(cacheCheckPromises);

        const imageUidsToFetch = cacheChecked
          .filter((ch) => ch.needsFetch)
          .map((ch) => ch.imageUid)
          .filter(Boolean);

        let fetchedImages: Record<
          string,
          { image: string; timestamp: string }
        > = {};
        if (imageUidsToFetch.length > 0) {
          try {
            fetchedImages = await fetchImagesByUid(imageUidsToFetch);
          } catch (err) {
            console.error(
              "❌ Image fetch failed for assigned challenges:",
              err,
            );
          }
        }

        assigned = await Promise.all(
          cacheChecked.map(async (challenge: any) => {
            try {
              const { imageUid, imageTimestamp, cachedUrl } = challenge;

              if (!imageUid) {
                challenge.cachedImageUrl = "fallback.png";
                return challenge;
              }
              if (cachedUrl) {
                challenge.cachedImageUrl = cachedUrl;
                return challenge;
              }

              const fetchedImageData = fetchedImages[imageUid];

              if (fetchedImageData && fetchedImageData.image) {
                await saveImageToCache(
                  imageUid,
                  imageUid,
                  fetchedImageData.image,
                  fetchedImageData.timestamp,
                );
                const newUrl = await getImageFromCache(
                  imageUid,
                  fetchedImageData.timestamp,
                );
                challenge.cachedImageUrl = newUrl || "fallback.png";
              } else {
                challenge.cachedImageUrl = "fallback.png";
              }
            } catch (err) {
              console.error(
                "❌ Error processing assigned challenge image:",
                err,
              );
              challenge.cachedImageUrl = "fallback.png";
            }

            return challenge;
          }),
        );

        setAssignedChallenges(assigned);
      } else {
        setAssignedChallenges([]);
        openNotification({
          type: "error",
          message: data.message || "Failed to fetch assigned challenges",
        });
      }
    } catch (error) {
      console.error("Error fetching assigned challenges:", error);
      setAssignedChallenges([]);
      openNotification({
        type: "error",
        message: "An error occurred while fetching assigned challenges",
      });
    } finally {
      setLoadingAssignedChallenges(false);
    }
  };

  // Handle download challenge report
  const handleDownloadReport = async (challenge: Challenge) => {
    try {
      const response = await axios.get(
        `${beAddress}/api/challenge-leaderboard-report`,
        {
          params: {
            challenge_uid: challenge.challenge_uid,
          },
          headers: {
            "user-uid": userUid,
            "session-uid": sessionUid,
          },
          withCredentials: true,
        }
      );

      // Check if response is a PDF (blob) or error message (JSON)
      const contentType = response.headers['content-type'];
      
      if (contentType && contentType.includes('application/pdf')) {
        // Handle PDF download
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Get filename from response headers or use default
        const contentDisposition = response.headers['content-disposition'];
        let filename = `challenge-report-${challenge.challenge_name}.pdf`;
        
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        openNotification({
          type: "success",
          message: "Report downloaded successfully!",
        });
      } else {
        // Handle error/warning message from backend
        const responseData = response.data;
        const message = responseData?.data || responseData?.data || "No report data available";
        
        openNotification({
          type: "warning",
          message: message,
        });
      }
    } catch (error: any) {
      console.error("Error fetching report:", error);
      
      // Check if error response contains a message
      if (error.response?.data) {
        const errorMessage = error.response.data?.message || error.response.data?.data || "Failed to fetch report";
        openNotification({
          type: "warning",
          message: errorMessage,
        });
      } else {
        openNotification({
          type: "error",
          message: "Failed to download report. Please try again.",
        });
      }
    }
  };

  // Restored functionality including History option
  const handleDropDownOptionClick = (option: string, challenge: Challenge) => {
    if (option === "edit") {
      navigate("/create-challenges", { state: { challenge } });
    } else if (option === "delete") {
      setDeleteModal(true);
      setChallengeRecord(challenge);
    } else if (option === "assign") {
      setSelectedChallengeUid(challenge.challenge_uid);
      setModalType(challenge.challenge_type === "team" ? "team" : "individual");
      fetchChallengeMappings(challenge);
      if (challenge.challenge_type === "team") {
        getGroups();
      } else {
        getAllUsers();
      }
      setActiveTab("available");
      setIsModalOpen(true);
    } else if (option === "history") {
      // Handle View History
      if (challenge.history_uid) {
        setHistoryUid(challenge.history_uid);
        setShowHistoryModal(true);
      } else {
        openNotification({
          type: "warning",
          message: "No history available for this challenge",
        });
      }
    } else if (option === "report") {
      // Handle Report Download
      handleDownloadReport(challenge);
    }
    setIsDropdownVisible(null);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  const challengesToRender =
    viewMode === "all" ? challengesData : assignedChallenges;
  const filteredChallenges = challengesToRender.filter(
    (challenge) =>
      (challenge.challenge_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
        challenge.challenge_desc
          .toLowerCase()
          .includes(searchQuery.toLowerCase())) &&
      challenge.challenge_status === getChallengeStatusValue(selectedTab),
  );

  interface IndividualOption {
    value: string;
    label: string;
    image: string;
    role: string;
  }

  interface TeamOption {
    name: string;
    location: string;
  }

  useEffect(() => {
    return () => {
      challengesData.forEach((challenge) => {
        if (
          challenge.cachedImageUrl &&
          challenge.cachedImageUrl.startsWith("blob:")
        ) {
          URL.revokeObjectURL(challenge.cachedImageUrl);
        }
      });
      assignedChallenges.forEach((challenge) => {
        if (
          challenge.cachedImageUrl &&
          challenge.cachedImageUrl.startsWith("blob:")
        ) {
          URL.revokeObjectURL(challenge.cachedImageUrl);
        }
      });
    };
  }, [challengesData, assignedChallenges]);

  type FilterKey = "1m" | "3m" | "6m" | "1y" | "all";
  const handleFilterSelect = (value: FilterKey) => {
    setSelectedFilter(value);
    setShowFilterDropdown(false);

    if (viewMode === "all") {
      getChallangesData(value);
    } else if (viewMode === "my") {
      handleAssignedChallenges(value); // Pass the filter value
    }
  };

  const filteredMappedMembers = useMemo(() => {
    if (!searchTerm.trim() || !mappedMembers.length) {
      return mappedMembers;
    }

    const searchLower = searchTerm.toLowerCase();

    return mappedMembers.filter((member) => {
      // For team challenges
      if (modalType === "team") {
        return member.group_name?.toLowerCase().includes(searchLower);
      }

      // For individual challenges
      if (modalType === "individual" && member.user_list) {
        return member.user_list.some((user: any) =>
          (user.user_name || user.user_uid || "")
            .toLowerCase()
            .includes(searchLower),
        );
      }

      return false;
    });
  }, [mappedMembers, searchTerm, modalType]);

  const filteredMappedUsers = useMemo(() => {
    if (!searchTerm.trim() || modalType !== "individual") {
      return mappedMembers;
    }

    const searchLower = searchTerm.toLowerCase();

    return mappedMembers
      .map((member) => {
        if (!member.user_list) return member;

        const filteredUserList = member.user_list.filter((user: any) =>
          (user.user_name || user.user_uid || "")
            .toLowerCase()
            .includes(searchLower),
        );

        return {
          ...member,
          user_list: filteredUserList,
        };
      })
      .filter((member) => member.user_list && member.user_list.length > 0);
  }, [mappedMembers, searchTerm, modalType]);

  const formatDateForDisplay = (dateInput: Date | string): string => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

    const pad = (n: number) => String(n).padStart(2, "0");
    return (
      date.getUTCFullYear() +
      "-" +
      pad(date.getUTCMonth() + 1) +
      "-" +
      pad(date.getUTCDate()) +
      "T" +
      pad(date.getUTCHours()) +
      ":" +
      pad(date.getUTCMinutes()) +
      ":" +
      pad(date.getUTCSeconds()) +
      "Z"
    );
  };

  const applyFilterParams = (filterKey: FilterKey) => {
    const today = new Date();
    let fromDate: Date = new Date(today);
    let toDate: Date = new Date(today);
    switch (filterKey) {
      case "1m":
        fromDate.setMonth(today.getMonth() - 1);
        toDate.setMonth(today.getMonth() + 1);
        break;

      case "3m":
        fromDate.setMonth(today.getMonth() - 3);
        toDate.setMonth(today.getMonth() + 3);
        break;
      case "6m":
        fromDate.setMonth(today.getMonth() - 6);
        toDate.setMonth(today.getMonth() + 6);
        break;
      case "1y":
        fromDate.setFullYear(today.getFullYear() - 1);
        toDate.setFullYear(today.getFullYear() + 1);
        break;
      case "all":
      default:
        return {};
    }

    return {
      from_datetime: formatDateForDisplay(fromDate),
      to_datetime: formatDateForDisplay(toDate),
    };
  };

  // useEffect(() => {
  //   if (viewMode === "all") {
  //     getChallangesData(selectedFilter);
  //   } else if (viewMode === "my") {
  //     handleAssignedChallenges(selectedFilter);
  //   }
  // }, []);

  useEffect(() => {
    if (viewMode === "all") {
      getChallangesData(selectedFilter);
    } else if (viewMode === "my") {
      handleAssignedChallenges(selectedFilter);
    }
  }, [viewMode, selectedFilter]);

  useEffect(() => {
  // Force data refresh when component mounts
  const fetchData = async () => {
    if (viewMode === "all") {
      await getChallangesData(selectedFilter);
    } else if (viewMode === "my") {
      await handleAssignedChallenges(selectedFilter);
    }
  };
  fetchData();
}, [viewMode, selectedFilter]); // Add dependencies

// Add this effect to handle navigation focus/visibility
useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      // Refresh data when tab becomes visible again
      if (viewMode === "all") {
        getChallangesData(selectedFilter);
      } else if (viewMode === "my") {
        handleAssignedChallenges(selectedFilter);
      }
    }
  };
  document.addEventListener('visibilitychange', handleVisibilityChange);
  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}, [viewMode, selectedFilter]);

// Add this to detect when component comes back into focus
useEffect(() => {
  const handleFocus = () => {
    // Refresh data when window gains focus
    if (viewMode === "all") {
      getChallangesData(selectedFilter);
    } else if (viewMode === "my") {
      handleAssignedChallenges(selectedFilter);
    }
  };
  window.addEventListener('focus', handleFocus);
  return () => {
    window.removeEventListener('focus', handleFocus);
  };
}, [viewMode, selectedFilter]);

  const filterLabels: any = {
    "1m": "1 Month",
    "3m": "3 Months",
    "6m": "6 Months",
    "1y": "1 Year",
    all: "All Time",
  };
  const defaultFilter: FilterKey = "3m";

  const handleViewModeChange = (mode: "all" | "my") => {
    setSelectedFilter(defaultFilter);
    setShowFilterDropdown(false);
    setViewMode(mode);

    // Immediately fetch data for the new view mode
    if (mode === "all") {
      getChallangesData(defaultFilter);
    } else if (mode === "my") {
      handleAssignedChallenges(defaultFilter);
    }
  };
  return (
    <>
      <ViewToggleContainer>
        <ViewToggleButton
          active={viewMode === "my"}
          onClick={() => handleViewModeChange("my")}
        >
          My Challenges
        </ViewToggleButton>
        <ViewToggleButton
          active={viewMode === "all"}
          onClick={() => handleViewModeChange("all")}
        >
          All Challenges
        </ViewToggleButton>
      </ViewToggleContainer>

      <Container>
        <ContainerFlex1>
          {/* Search Bar */}
          <div className="challenges-topbar-search-box">
            <CiSearch
              color="var(--text-color)"
              className="challenges-topbar-search-icon"
            />
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              className="challenges-search-bar"
            />
          </div>

          {/* Month Filter */}
          <TopBarFilterWrapper>
            <TopBarFilterBtn
              onClick={() => setShowFilterDropdown(!showFilterDropdown)}
            >
              {filterLabels[selectedFilter] || "Filter"}
              <span className={showFilterDropdown ? "rotate" : ""}>
                <RiArrowDropDownLine style={{ fontSize: "28px" }} />
              </span>
            </TopBarFilterBtn>

            {showFilterDropdown && (
              <TopBarFilterDropdown>
                {viewMode === "my" && (
                  <>
                    <div onClick={() => handleFilterSelect("1m")}>1 Month</div>
                    <div onClick={() => handleFilterSelect("3m")}>3 Months</div>
                    <div onClick={() => handleFilterSelect("6m")}>6 Months</div>
                    <div onClick={() => handleFilterSelect("1y")}>1 Year</div>
                    <div onClick={() => handleFilterSelect("all")}>
                      All Time
                    </div>
                  </>
                )}

                {viewMode === "all" && (
                  <>
                    <div onClick={() => handleFilterSelect("1m")}>1 Month</div>
                    <div onClick={() => handleFilterSelect("3m")}>3 Months</div>
                    <div onClick={() => handleFilterSelect("6m")}>6 Months</div>
                    <div onClick={() => handleFilterSelect("1y")}>1 Year</div>
                  </>
                )}
              </TopBarFilterDropdown>
            )}
          </TopBarFilterWrapper>

          {/* Date Range Display */}
          <DateRangeDisplay>
            <span className="date-range-text">
              {formatDateForDisplayUI(getDisplayFromDate(selectedTab))} -{" "}
              {formatDateForDisplayUI(getDisplayToDate(selectedTab))}
            </span>
          </DateRangeDisplay>

          {/* Create Button (only for orgadmin/creator) */}
          {(privilege === "orgadmin" || user_role === "creator") &&
            viewMode !== "my" && (
              <div className="challenges-new-challange-block">
                <span>New Challenge? </span>
                <button onClick={() => navigate("/create-challenges")}>
                  CREATE
                </button>
              </div>
            )}
        </ContainerFlex1>
        <ContainerFlex2>
          {["Upcoming", "Ongoing", "Ended"].map((tab) => (
            <button
              key={tab}
              className={selectedTab === tab ? "selected" : ""}
              onClick={() => setSelectedTab(tab)}
            >
              {tab}
            </button>
          ))}
        </ContainerFlex2>
        <ContainerFlex3>
          {(loadingChallenges && viewMode === "all") ||
          (loadingAssignedChallenges && viewMode === "my") ? (
            <>
              {[...Array(4)].map((_, i) => (
                <SkeletonLoader key={i} type="challenge-card" />
              ))}
            </>
          ) : filteredChallenges.length > 0 ? (
            filteredChallenges.map((challenge) => (
              <Card
                onClick={async (e) => {
                  if (menuClicked) {
                    setMenuClicked(false);
                    return;
                  }

                  const selectedChallenge = {
                    org_uid: challenge.org_uid,
                    challenge_uid: challenge.challenge_uid,
                    challenge_name: challenge.challenge_name,
                    challenge_desc: challenge.challenge_desc,
                    challenge_type: challenge.challenge_type,
                    metric_type: challenge.metric_type,
                    from_datetime: challenge.from_datetime,
                    to_datetime: challenge.to_datetime,
                    visibility: challenge.visibility,
                    goal_count: challenge.goal_count,
                    goal_evaluation_mode: challenge.goal_evaluation_mode,
                    max_participants: challenge.max_participants,
                    challenge_status: challenge.challenge_status,
                    last_registration_date: challenge.last_registration_date,
                    prize_pool: challenge.prize_pool,
                    members_joined: challenge.members_joined,
                    image_uid: challenge.image_uid,
                    image_timestamp: challenge.image_timestamp,
                    joined: challenge.joined,
                  };
                  localStorage.setItem(
                    "selectedChallenge",
                    JSON.stringify(selectedChallenge),
                  );
                  let imageToSend = "";

                  if (challenge.cachedImageUrl?.startsWith("blob:")) {
                    const blob = await fetch(challenge.cachedImageUrl).then(
                      (r) => r.blob(),
                    );
                    imageToSend = await new Promise((res) => {
                      const reader = new FileReader();
                      reader.onloadend = () => res(reader.result as string);
                      reader.readAsDataURL(blob);
                    });
                  } else if (challenge.image?.startsWith("data:image")) {
                    imageToSend = challenge.image;
                  } else {
                    imageToSend = "";
                  }

                  navigate("/Challenges-dashboard", {
                    state: {
                      ...selectedChallenge,
                      image: imageToSend,
                      image_uid: challenge.image_uid,
                      image_timestamp: challenge.image_timestamp,
                    },
                  });
                }}
              >
                <ImageContainer>
                  <Image
                    src={challenge.cachedImageUrl || "fallback.png"}
                    alt={challenge.challenge_name}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      if (
                        target.src !==
                        window.location.origin + "/fallback.png"
                      ) {
                        target.src = "fallback.png";
                      }
                    }}
                  />

                  <Overlay>
                    <TopRow>
                      <Metric>
                        <span style={{ marginRight: "8px" }}>
                          {ChallangeIcon(challenge.metric_type)}
                        </span>
                        {ChallangeText(challenge.metric_type)}
                      </Metric>

                      {viewMode === "my" &&
                        challenge.challenge_type === "individual" &&
                        selectedTab !== "Ended" &&
                        !challenge.rejoin && ( // Add this condition
                          <div style={{ position: "relative" }}>
                            <MenuButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setMenuClicked(true);
                                if (
                                  showMenuForChallenge ===
                                  challenge.challenge_uid
                                ) {
                                  setShowMenuForChallenge(null);
                                } else {
                                  setShowMenuForChallenge(
                                    challenge.challenge_uid,
                                  );
                                }
                              }}
                            >
                              <IoEllipsisVertical />
                            </MenuButton>

                            {showMenuForChallenge ===
                              challenge.challenge_uid && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  right: 0,
                                  background: "#fff",
                                  borderRadius: "6px",
                                  boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                                  zIndex: 999,
                                }}
                              >
                                <button
                                  style={{
                                    padding: "10px 16px",
                                    width: "100%",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#dc3545",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background =
                                      "#f8f9fa")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = "none")
                                  }
                                  onClick={() => {
                                    setSelectedChallengeToQuit({
                                      ...challenge,
                                      start_datetime:
                                        (challenge as HomepageChallenge)
                                          .start_datetime ||
                                        challenge.from_datetime,
                                      end_datetime:
                                        (challenge as HomepageChallenge)
                                          .end_datetime ||
                                        challenge.to_datetime,
                                      group_uid:
                                        (challenge as HomepageChallenge)
                                          .group_uid || "",
                                      user_uid:
                                        (challenge as HomepageChallenge)
                                          .user_uid || "",
                                    });
                                    setShowQuitModal(true);
                                    setShowMenuForChallenge(null);
                                  }}
                                >
                                  Quit Challenge
                                </button>
                              </div>
                            )}
                          </div>
                        )}

                      {isOrgAdmin && viewMode === "all" && (
                        <MenuButton>
                          <IoEllipsisVertical
                            onClick={(e) => {
                              e.stopPropagation();
                              setMenuClicked(true);
                              toggleDropdown(challenge.challenge_uid);
                            }}
                          />
                          {isDropdownVisible === challenge.challenge_uid && (
                            <div
                              className="challenges-get-dropdown-block"
                              ref={dropdownRef}
                            >
                              {selectedTab !== "Ended" && (
                                <>
                                  <div
                                    className="challenges-get-dropdown-option"
                                    onClick={() =>
                                      handleDropDownOptionClick(
                                        "edit",
                                        challenge,
                                      )
                                    }
                                  >
                                    <FaEdit /> Edit
                                  </div>
                                  <div
                                    className="challenges-get-dropdown-option"
                                    onClick={() =>
                                      handleDropDownOptionClick(
                                        "assign",
                                        challenge,
                                      )
                                    }
                                  >
                                    <MdAssignmentInd /> Assign
                                  </div>
                                </>
                              )}
                              {/* Preserved History Option */}
                              <div
                                className="challenges-get-dropdown-option"
                                onClick={() =>
                                  handleDropDownOptionClick(
                                    "report",
                                    challenge,
                                  )
                                }
                              >
                                <FaDownload />
                                Report
                              </div>
                              <div
                                className="challenges-get-dropdown-option"
                                onClick={() =>
                                  handleDropDownOptionClick(
                                    "history",
                                    challenge,
                                  )
                                }
                              >
                                <FaHistory />
                                History
                              </div>
                              {selectedTab !== "Ended" && (
                                <div
                                  className="challenges-get-dropdown-option"
                                  onClick={() =>
                                    handleDropDownOptionClick(
                                      "delete",
                                      challenge,
                                    )
                                  }
                                >
                                  <FaTrash /> Delete
                                </div>
                              )}
                            </div>
                          )}
                        </MenuButton>
                      )}
                    </TopRow>

                    <OverlayInfo>
                      <OverlayLeft>
                        {/* Show both Private and Public with white background and green text */}
                        <VisibilityBadge>
                          {challenge.visibility === "private"
                            ? "Private"
                            : "Public"}
                        </VisibilityBadge>
                      </OverlayLeft>

                      <OverlayRight>
                        {challenge.joined ? (
                          <Badge>Joined</Badge>
                        ) : (challenge.join || challenge.rejoin) &&
                          challenge.visibility === "public" &&
                          challenge.challenge_type === "individual" &&
                          selectedTab !== "Ended" ? (
                          <JoinButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleJoinChallenge(challenge);
                            }}
                          >
                            {challenge.join
                              ? "Join"
                              : challenge.rejoin
                                ? "Rejoin"
                                : null}
                          </JoinButton>
                        ) : null}

                        <Titlename>{challenge.challenge_name}</Titlename>
                        <Subtitle>
                          {(() => {
                            // Get the proper metric text based on metric_type
                            let metricDisplay = ChallangeText(
                              challenge.metric_type,
                            );

                            // Override for specific metric types
                            if (challenge.metric_type === "distance") {
                              metricDisplay = "meters";
                            } else if (
                              challenge.metric_type === "caloriesburned"
                            ) {
                              metricDisplay = "kcal";
                            }

                            const goalText = `${challenge.goal_count} ${metricDisplay}`;
                            const evaluationText =
                              challenge.goal_evaluation_mode === "daily"
                                ? " per day"
                                : "";
                            return `Goal: ${goalText}${evaluationText}`;
                          })()}
                        </Subtitle>
                        <StyledDate>
                          {formatDateRange(
                            getChallengeStartDate(challenge),
                            getChallengeEndDate(challenge),
                          )}
                        </StyledDate>
                        {/* {challenge.challenge_status === "inactive" && (
                          <StatusTag variant="warning">
                            Last Registration:{" "}
                            {formatDate(challenge.last_registration_date)}
                          </StatusTag>
                        )} */}
                        {viewMode === "all" &&
                          (challenge.challenge_status === "inactive" ||
                            challenge.challenge_status === "active") && (
                            <StatusTag variant="warning">
                              Last Registration:{" "}
                              {challenge.last_registration_date &&
                              !isNaN(
                                new Date(
                                  challenge.last_registration_date,
                                ).getTime(),
                              )
                                ? formatDate(challenge.last_registration_date)
                                : "To be announced"}
                            </StatusTag>
                          )}
                      </OverlayRight>
                    </OverlayInfo>
                  </Overlay>
                </ImageContainer>

                <Info>
                  <Title>{challenge.challenge_desc}</Title>
                </Info>

                <BottomRow>
                  <JoinedInfo>
                    <LeftInfo>
                      <JoinedText>
                        <FaHeart /> {challenge.members_joined} joined
                      </JoinedText>
                    </LeftInfo>
                    <RightInfo>
                      <JoinedText1>
                        {challenge.challenge_type === "team"
                          ? "Team"
                          : "Individual"}
                      </JoinedText1>
                    </RightInfo>
                  </JoinedInfo>
                </BottomRow>
              </Card>
            ))
          ) : (
            <span className="challanges-empty-data-span">
              No Challenges to show
            </span>
          )}
        </ContainerFlex3>

        {isViewModalOpen && viewModalChallenge && (
          <Modal
            isOpen={isViewModalOpen}
            onRequestClose={() => setIsViewModalOpen(false)}
            className="challange-custom-modal"
            overlayClassName="challange-custom-overlay"
            style={{
              content: {
                maxHeight: "80vh",
                overflowY: "auto",
                padding: "20px",
                borderRadius: "10px",
              },
            }}
          >
            <button
              className="modal-close-button"
              onClick={() => setIsViewModalOpen(false)}
            >
              &times;
            </button>

            <h2>{viewModalChallenge.challenge_name}</h2>

            {viewModalChallenge.challenge_type === "team" ? (
              mappedMembers.length > 0 ? (
                mappedMembers.map((team, idx) => (
                  <div
                    key={idx}
                    style={{
                      marginBottom: "12px",
                      background: "#f5f5f5",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "1rem",
                      }}
                      onClick={() =>
                        setExpandedTeamUid(
                          expandedTeamUid === team.group_uid
                            ? null
                            : team.group_uid,
                        )
                      }
                    >
                      {team.group_name}
                    </div>
                    {expandedTeamUid === team.group_uid && (
                      <div style={{ marginTop: "10px" }}>
                        {team.user_list?.map((user: any, idx2: number) => {
                          const percent =
                            Math.floor(
                              (user.user_challenge_status_metrics /
                                user.goal_count) *
                                100,
                            ) || 0;
                          return (
                            <div
                              key={idx}
                              style={{
                                background: "#f5f5f5",
                                padding: "10px",
                                marginBottom: "8px",
                                borderRadius: "8px",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div style={{ textAlign: "left" }}>
                                <p>
                                  <strong>User:</strong> {user.user_uid}
                                </p>
                                <p>
                                  <strong>Metric:</strong> {user.metric_type}
                                </p>
                                <p>
                                  <strong>Status:</strong>{" "}
                                  {user.user_challenge_status || "Not Started"}
                                </p>
                                <p>
                                  <strong>Start:</strong>{" "}
                                  {user.start_datetime
                                    ? new Date(
                                        user.start_datetime,
                                      ).toLocaleString()
                                    : "N/A"}
                                </p>
                                <p>
                                  <strong>End:</strong>{" "}
                                  {user.end_datetime
                                    ? new Date(
                                        user.end_datetime,
                                      ).toLocaleString()
                                    : "N/A"}
                                </p>
                              </div>

                              <div style={{ textAlign: "center" }}>
                                <div
                                  style={{
                                    width: 60,
                                    height: 60,
                                    margin: "0 auto",
                                  }}
                                >
                                  <CircularProgressbar
                                    value={percent}
                                    text={`${percent}%`}
                                    styles={buildStyles({
                                      pathColor: "orange",
                                      textColor: "#333",
                                      trailColor: "#eee",
                                    })}
                                  />
                                </div>
                                <div
                                  style={{ fontSize: "12px", marginTop: "6px" }}
                                >
                                  <div>
                                    <strong>Goal:</strong> {user.goal_count}
                                  </div>
                                  <div>
                                    <strong>Achieved:</strong>{" "}
                                    {user.user_challenge_status_metrics}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No Teams mapped yet.</p>
              )
            ) : mappedMembers.length > 0 ? (
              mappedMembers.flatMap((entry, idx) =>
                entry.user_list.map((user: any, subIdx: number) => {
                  const percent =
                    Math.floor(
                      (user.user_challenge_status_metrics / user.goal_count) *
                        100,
                    ) || 0;
                  return (
                    <div
                      key={`${idx}-${subIdx}`}
                      style={{
                        background: "#f5f5f5",
                        padding: "10px",
                        marginBottom: "8px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <p>
                          <strong>User:</strong> {user.user_uid}
                        </p>
                        <p>
                          <strong>Metric:</strong> {user.metric_type}
                        </p>
                        <p>
                          <strong>Status:</strong>{" "}
                          {user.user_challenge_status || "Not Started"}
                        </p>
                        <p>
                          <strong>Start:</strong>{" "}
                          {user.start_datetime
                            ? new Date(user.start_datetime).toLocaleString()
                            : "N/A"}
                        </p>
                        <p>
                          <strong>End:</strong>{" "}
                          {user.end_datetime
                            ? new Date(user.end_datetime).toLocaleString()
                            : "N/A"}
                        </p>
                      </div>

                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{ width: 60, height: 60, margin: "0 auto" }}
                        >
                          <CircularProgressbar
                            value={percent}
                            text={`${percent}%`}
                            styles={buildStyles({
                              pathColor: "orange",
                              textColor: "#333",
                              trailColor: "#eee",
                            })}
                          />
                        </div>
                        <div style={{ fontSize: "12px", marginTop: "6px" }}>
                          <div>
                            <strong>Goal:</strong> {user.goal_count}
                          </div>
                          <div>
                            <strong>Achieved:</strong>{" "}
                            {user.user_challenge_status_metrics}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }),
              )
            ) : (
              <p>No Users mapped yet.</p>
            )}
          </Modal>
        )}

        <ConfirmationDialog
          show={showDeleteConfirmModal}
          onClose={() => setShowDeleteConfirmModal(false)}
          onCancel={() => setShowDeleteConfirmModal(false)}
          onConfirm={async () => {
            try {
              const deletePayload = selectedToDelete.map((entry) => ({
                challenge_uid: selectedChallengeUid,
                org_uid: entry.org_uid,
                ...(modalType === "team"
                  ? { group_uid: entry.group_uid }
                  : { user_uid: entry.user_uid }),
              }));
              const response = await axios.delete(
                `${process.env.REACT_APP_API_URL}/api/challenges-maping`,
                {
                  headers: {
                    accept: "application/json",
                    "user-uid": userUid,
                  },
                  withCredentials: true,
                  data: deletePayload,
                },
              );
              if (response.data?.status === "Success") {
                openNotification({
                  type: "success",
                  message: "Selected mappings removed successfully",
                });
                setMappedMembers((prev) =>
                  prev.filter((item) =>
                    modalType === "team"
                      ? !selectedToDelete.some(
                          (del) => del.group_uid === item.group_uid,
                        )
                      : !selectedToDelete.some(
                          (del) => del.user_uid === item.user_uid,
                        ),
                  ),
                );
              } else {
                openNotification({
                  type: "error",
                  message:
                    response.data?.message || "Failed to remove mappings",
                });
              }
            } catch (err) {
              openNotification({
                type: "error",
                message: "Error occurred while deleting mappings",
              });
            }

            setShowDeleteConfirmModal(false);
            setSelectedToDelete([]);
            setShowDeleteSelect(false);
          }}
          message={`Are you sure you want to remove selected ${
            modalType === "team" ? "teams" : "users"
          }?`}
          confirmText="Yes, Remove"
          cancelText="Cancel"
        />
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {
            setIsModalOpen(false);
            // Reset all modal states
            setSearchTerm("");
            setAssignIndividual([]);
            setSelectedTeam([]);
            setShowDeleteSelect(false);
            setSelectedMappedItems([]);
            setActiveTab("available");
          }}
          style={{
            content: {
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
            },
          }}
          className="challange-custom-modal"
          overlayClassName="challange-custom-overlay"
        >
          {/* Header - Fixed */}
          <div style={{ flexShrink: 0, marginBottom: "16px" }}>
            <button
              className="modal-close-button"
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>
            <h2 style={{ marginTop: "8px" }}>
              Select {modalType === "individual" ? "Individuals" : "Teams"}
            </h2>
          </div>

          {/* Tabs - Fixed */}
          <AssignTabContainer style={{ flexShrink: 0 }}>
            <AssignTabButton
              active={activeTab === "available"}
              onClick={() => setActiveTab("available")}
            >
              Available
            </AssignTabButton>
            <AssignTabButton
              active={activeTab === "mapped"}
              onClick={() => setActiveTab("mapped")}
            >
              Mapped
            </AssignTabButton>
          </AssignTabContainer>

          {/* Search - Fixed */}
          <div style={{ flexShrink: 0, margin: "16px 0" }}>
            <input
              type="text"
              placeholder="Search..."
              style={{
                width: "90%",
                padding: "10px 14px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontSize: "14px",
              }}
              value={searchTerm}
              // onChange={(e) => setSearchTerm(e.target.value)}
              onChange={handleSearchChange}
            />
          </div>

          {/* Delete Selection Header - Fixed */}
          {activeTab === "mapped" && mappedMembers.length > 0 && (
            <div
              style={{
                flexShrink: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
                padding: "8px 0",
                borderBottom: showDeleteSelect ? "1px solid #e8e8e8" : "none",
              }}
            >
              {showDeleteSelect ? (
                <>
                  <div>
                    <strong>
                      {selectedMappedItems.length} item(s) selected
                    </strong>
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      style={{
                        background: "#6c757d",
                        color: "white",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        setShowDeleteSelect(false);
                        setSelectedMappedItems([]);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      style={{
                        background: "#ff4d4f",
                        color: "white",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        if (selectedMappedItems.length > 0) {
                          setShowDeleteConfirmModal(true);
                        }
                      }}
                      disabled={selectedMappedItems.length === 0}
                    >
                      Remove Selected
                    </button>
                  </div>
                </>
              ) : (
                <button
                  style={{
                    background: "#ff4d4f",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    fontWeight: 500,
                    width: "100%",
                  }}
                  onClick={() => setShowDeleteSelect(true)}
                >
                  {modalType === "individual" ? "Remove Users" : "Remove Teams"}
                </button>
              )}
            </div>
          )}

          {/* Scrollable Content Area - Only the list */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              minHeight: "200px",
              maxHeight: "calc(80vh - 350px)", // Adjust based on fixed elements height
              marginBottom: "16px",
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              padding: "8px",
            }}
          >
            {activeTab === "available" ? (
              modalType === "individual" ? (
                <MemberListContainer>
                  <SelectAllRow>
                    <strong>Select All Users ({filteredUsers.length})</strong>
                    <input
                      type="checkbox"
                      checked={
                        filteredUsers.length > 0 &&
                        filteredUsers.every((user) =>
                          assignIndividual.some(
                            (selected) => selected.value === user.value,
                          ),
                        )
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          const newSelections = filteredUsers.filter(
                            (user) =>
                              !assignIndividual.some(
                                (selected) => selected.value === user.value,
                              ),
                          );
                          setAssignIndividual((prev) => [
                            ...prev,
                            ...newSelections,
                          ]);
                        } else {
                          setAssignIndividual((prev) =>
                            prev.filter(
                              (selected) =>
                                !filteredUsers.some(
                                  (user) => user.value === selected.value,
                                ),
                            ),
                          );
                        }
                      }}
                    />
                  </SelectAllRow>

                  {filteredUsers.length === 0 ? (
                    <div className="no-results">
                      <p>No user found</p>
                    </div>
                  ) : (
                    filteredUsers.map((person, index) => {
                      const isSelected = assignIndividual.some(
                        (u) => u.value === person.value,
                      );

                      return (
                        <MemberCard
                          key={person.value || index}
                          className={isSelected ? "selected" : ""}
                        >
                          <MemberInfo>
                            <Avatar src={person.image} alt={person.label} />
                            <MemberDetails>
                              <MemberName>{person.label}</MemberName>
                              {person.email && (
                                <div
                                  style={{ fontSize: "12px", color: "#666" }}
                                >
                                  {person.email}
                                </div>
                              )}
                            </MemberDetails>
                          </MemberInfo>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setAssignIndividual((prev) => [
                                  ...prev,
                                  person,
                                ]);
                              } else {
                                setAssignIndividual((prev) =>
                                  prev.filter((u) => u.value !== person.value),
                                );
                              }
                            }}
                          />
                        </MemberCard>
                      );
                    })
                  )}
                </MemberListContainer>
              ) : (
                <TeamListContainer>
                  <SelectAllRow>
                    <strong>
                      Select All Teams ({filteredTeamRecords.length})
                    </strong>
                    <input
                      type="checkbox"
                      checked={
                        filteredTeamRecords.length > 0 &&
                        filteredTeamRecords.every((team) =>
                          selectedTeam.some(
                            (selected) => selected.group_uid === team.group_uid,
                          ),
                        )
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          // Select all filtered teams
                          const newSelections = filteredTeamRecords.filter(
                            (team) =>
                              !selectedTeam.some(
                                (selected) =>
                                  selected.group_uid === team.group_uid,
                              ),
                          );
                          setSelectedTeam((prev) => [
                            ...prev,
                            ...newSelections,
                          ]);
                        } else {
                          // Deselect all filtered teams
                          setSelectedTeam((prev) =>
                            prev.filter(
                              (selected) =>
                                !filteredTeamRecords.some(
                                  (team) =>
                                    team.group_uid === selected.group_uid,
                                ),
                            ),
                          );
                        }
                      }}
                    />
                  </SelectAllRow>

                  {filteredTeamRecords.length === 0 ? (
                    <div className="no-results">
                      <p>
                        {searchTerm.trim()
                          ? `No teams found matching ${searchTerm}`
                          : "No teams available for this challenge"}
                      </p>
                    </div>
                  ) : (
                    filteredTeamRecords.map((team, index) => {
                      const isSelected = selectedTeam.some(
                        (t) => t.group_uid === team.group_uid,
                      );

                      return (
                        <TeamCard
                          key={team.group_uid || index}
                          className={isSelected ? "selected" : ""}
                        >
                          <TeamRow>
                            <TeamName>{team.group_name}</TeamName>
                            <TeamCount>
                              {typeof team.users_count === "number"
                                ? `${team.users_count} members`
                                : "0 members"}
                            </TeamCount>
                          </TeamRow>

                          <input
                            type="checkbox"
                            checked={isSelected}
                            disabled={team.users_count === 0}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedTeam((prev) => [...prev, team]);
                              } else {
                                setSelectedTeam((prev) =>
                                  prev.filter(
                                    (t) => t.group_uid !== team.group_uid,
                                  ),
                                );
                              }
                            }}
                          />
                        </TeamCard>
                      );
                    })
                  )}
                </TeamListContainer>
              )
            ) : (
              // MAPPED TAB CONTENT - Scrollable list only
              <div className="mapped-list">
                {modalType === "individual" ? (
                  // INDIVIDUAL CHALLENGE - Show users list
                  <>
                    {showDeleteSelect && mappedMembers.length > 0 && (
                      <div style={{ marginBottom: "10px", padding: "8px 0" }}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={
                              mappedMembers.flatMap((m) => m.user_list || [])
                                .length > 0 &&
                              mappedMembers
                                .flatMap((m) => m.user_list || [])
                                .every((user: any) =>
                                  selectedMappedItems.some(
                                    (item) => item.user_uid === user.user_uid,
                                  ),
                                )
                            }
                            onChange={(e) => {
                              const allUsers = mappedMembers.flatMap(
                                (m) => m.user_list || [],
                              );
                              if (e.target.checked) {
                                const newSelections = allUsers.map(
                                  (user: any) => ({
                                    user_uid: user.user_uid,
                                    org_uid:
                                      user.org_uid || mappedMembers[0]?.org_uid,
                                    user_name: user.user_name,
                                  }),
                                );
                                setSelectedMappedItems(newSelections);
                              } else {
                                setSelectedMappedItems([]);
                              }
                            }}
                          />
                          <span>Select All Users</span>
                        </label>
                      </div>
                    )}

                    {filteredMappedUsers.length > 0 ? (
                      filteredMappedUsers.flatMap((entry, idx) =>
                        entry.user_list?.map((user: any, subIdx: number) => {
                          const isSelected = selectedMappedItems.some(
                            (item) => item.user_uid === user.user_uid,
                          );
                          return (
                            <div
                              key={`${idx}-${subIdx}`}
                              className="mapped-card"
                              style={{
                                background: "#fff",
                                padding: "12px",
                                marginBottom: "8px",
                                borderRadius: "8px",
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderLeft: isSelected
                                  ? "4px solid #ff4d4f"
                                  : "none",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {showDeleteSelect && (
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedMappedItems((prev) => [
                                          ...prev,
                                          {
                                            user_uid: user.user_uid,
                                            org_uid: entry.org_uid,
                                            user_name: user.user_name,
                                          },
                                        ]);
                                      } else {
                                        setSelectedMappedItems((prev) =>
                                          prev.filter(
                                            (item) =>
                                              item.user_uid !== user.user_uid,
                                          ),
                                        );
                                      }
                                    }}
                                  />
                                )}
                                <div style={{ textAlign: "left" }}>
                                  <p style={{ margin: 0, fontWeight: 600 }}>
                                    {user.user_name || user.user_uid}
                                  </p>
                                  <p
                                    style={{
                                      margin: "4px 0 0",
                                      fontSize: "12px",
                                      color: "#666",
                                    }}
                                  >
                                    Status: {user.user_status || "Unknown"}
                                  </p>
                                  {user.metric_type && (
                                    <p
                                      style={{
                                        margin: "2px 0 0",
                                        fontSize: "12px",
                                        color: "#666",
                                      }}
                                    >
                                      Metric: {user.metric_type}
                                    </p>
                                  )}
                                </div>
                              </div>

                              {!showDeleteSelect && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    minWidth: "80px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "0.75rem",
                                      padding: "4px 8px",
                                      borderRadius: "12px",
                                      background:
                                        user.user_progress_status ===
                                        "completed"
                                          ? "#d4edda"
                                          : user.user_progress_status ===
                                              "in_complete"
                                            ? "#fff3cd"
                                            : "#f8d7da",
                                      color:
                                        user.user_progress_status ===
                                        "completed"
                                          ? "#155724"
                                          : user.user_progress_status ===
                                              "in_complete"
                                            ? "#856404"
                                            : "#721c24",
                                    }}
                                  >
                                    {user.user_progress_status || "Not Started"}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        }),
                      )
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          color: "#666",
                          padding: "20px",
                        }}
                      >
                        {searchTerm.trim()
                          ? `No user found`
                          : "No users mapped yet."}
                      </p>
                    )}
                  </>
                ) : (
                  // TEAM CHALLENGE - Show teams list
                  <>
                    {showDeleteSelect && mappedMembers.length > 0 && (
                      <div style={{ marginBottom: "10px", padding: "8px 0" }}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={
                              mappedMembers.length > 0 &&
                              mappedMembers.every((team) =>
                                selectedMappedItems.some(
                                  (item) => item.group_uid === team.group_uid,
                                ),
                              )
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                const newSelections = mappedMembers.map(
                                  (team) => ({
                                    group_uid: team.group_uid,
                                    org_uid: team.org_uid,
                                    group_name: team.group_name,
                                  }),
                                );
                                setSelectedMappedItems(newSelections);
                              } else {
                                setSelectedMappedItems([]);
                              }
                            }}
                          />
                          <span>Select All Teams</span>
                        </label>
                      </div>
                    )}

                    {filteredMappedMembers.length > 0 ? (
                      filteredMappedMembers.map((team, idx) => {
                        const isSelected = selectedMappedItems.some(
                          (item) => item.group_uid === team.group_uid,
                        );

                        return (
                          <div
                            key={idx}
                            className="mapped-card"
                            style={{
                              background: "#fff",
                              padding: "12px",
                              marginBottom: "8px",
                              borderRadius: "8px",
                              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              borderLeft: isSelected
                                ? "4px solid #ff4d4f"
                                : "none",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {showDeleteSelect && (
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedMappedItems((prev) => [
                                        ...prev,
                                        {
                                          group_uid: team.group_uid,
                                          org_uid: team.org_uid,
                                          group_name: team.group_name,
                                        },
                                      ]);
                                    } else {
                                      setSelectedMappedItems((prev) =>
                                        prev.filter(
                                          (item) =>
                                            item.group_uid !== team.group_uid,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              )}
                              <div style={{ textAlign: "left" }}>
                                <p style={{ margin: 0, fontWeight: 600 }}>
                                  {team.group_name}
                                </p>
                                <p
                                  style={{
                                    margin: "4px 0 0",
                                    fontSize: "12px",
                                    color: "#666",
                                  }}
                                >
                                  Participants: {team.participants_count || 0}
                                </p>
                                <p
                                  style={{
                                    margin: "2px 0 0",
                                    fontSize: "12px",
                                    color: "#666",
                                  }}
                                >
                                  Active Users: {team.active_users_count || 0}
                                </p>
                              </div>
                            </div>

                            {!showDeleteSelect && (
                              <div
                                style={{
                                  textAlign: "center",
                                  minWidth: "80px",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "0.75rem",
                                    padding: "4px 8px",
                                    borderRadius: "12px",
                                    background: "#e6f4f5",
                                    color: "#094752",
                                  }}
                                >
                                  {team.participants_count || 0} members
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          color: "#666",
                          padding: "20px",
                        }}
                      >
                        {searchTerm.trim()
                          ? `No teams found matching "${searchTerm}"`
                          : "No teams mapped yet."}
                      </p>
                    )}
                  </>
                )}
              </div>
            )}
          </div>

          {/* Footer - Fixed */}
          <div
            style={{
              flexShrink: 0,
              borderTop: "1px solid #e8e8e8",
              paddingTop: "16px",
              marginTop: "auto",
            }}
          >
            {activeTab === "available" && (
              <button
                className="confirm-btn"
                onClick={handleAssignChallenge}
                disabled={
                  modalType === "individual"
                    ? assignIndividual.length === 0
                    : selectedTeam.length === 0
                }
                style={{
                  width: "100%",
                  padding: "12px",
                  background: (
                    modalType === "individual"
                      ? assignIndividual.length === 0
                      : selectedTeam.length === 0
                  )
                    ? "#cccccc"
                    : "#094752",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: (
                    modalType === "individual"
                      ? assignIndividual.length === 0
                      : selectedTeam.length === 0
                  )
                    ? "not-allowed"
                    : "pointer",
                  transition: "background 0.3s ease",
                }}
              >
                {modalType === "individual"
                  ? `Assign to ${assignIndividual.length} User${
                      assignIndividual.length !== 1 ? "s" : ""
                    }`
                  : `Assign to ${selectedTeam.length} Team${
                      selectedTeam.length !== 1 ? "s" : ""
                    }`}
              </button>
            )}
          </div>
        </Modal>
      </Container>
      {showQuitModal && selectedChallengeToQuit && (
        <ModalOverlay onClick={() => !isQuitting && setShowQuitModal(false)}>
          <QuitModalContainer onClick={(e) => e.stopPropagation()}>
            <QuitModalHeader>
              <WarningIcon>⚠️</WarningIcon>
              <QuitModalTitle>Quit Challenge</QuitModalTitle>
            </QuitModalHeader>

            <QuitModalMessage>
              Are you sure you want to quit{" "}
              <strong>"{selectedChallengeToQuit.challenge_name}"</strong>? You
              will lose your current progress and position on the leaderboard.
            </QuitModalMessage>

            <div>
              <QuitReasonLabel>
                Reason for quitting <span style={{ color: "#dc3545" }}>*</span>
              </QuitReasonLabel>
              <QuitReasonTextarea
                placeholder="Please let us know why you're quitting this challenge..."
                value={quitReason}
                onChange={(e) => setQuitReason(e.target.value)}
                disabled={isQuitting}
                maxLength={500}
              />
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "#9ca3af",
                  marginTop: "4px",
                  textAlign: "right",
                }}
              >
                {quitReason.length}/500
              </div>
            </div>

            <QuitModalActions>
              <CancelButton
                onClick={() => {
                  setShowQuitModal(false);
                  setQuitReason("");
                  setSelectedChallengeToQuit(null);
                }}
                disabled={isQuitting}
              >
                Cancel
              </CancelButton>
              <ConfirmQuitButton
                onClick={handleQuitChallenge}
                disabled={!quitReason.trim() || isQuitting}
              >
                {isQuitting ? (
                  <>
                    <span>Quitting...</span>
                  </>
                ) : (
                  "Yes, Quit Challenge"
                )}
              </ConfirmQuitButton>
            </QuitModalActions>
          </QuitModalContainer>
        </ModalOverlay>
      )}
      {deleteModal && (
        <ConfirmationDialog
          show={deleteModal}
          onClose={() => setDeleteModal(false)}
          onCancel={() => setDeleteModal(false)}
          onConfirm={async () => {
            const payload = [(challengeRecord as Challenge).challenge_uid];

            const response = await deleteChallenges(
              sessionUid,
              userUid,
              payload,
            );

            if (response?.status === "Success") {
              openNotification({
                type: "success",
                message: "Challenge deleted successfully!",
              });
              getChallangesData();
            } else {
              openNotification({
                type: "error",
                message: response?.message || "Failed to delete challenge.",
              });
            }

            setDeleteModal(false);
          }}
          message={`Are you sure you want to delete the challenge "${
            (challengeRecord as Challenge).challenge_name
          }"?`}
          confirmText="Yes, Delete"
          cancelText="Cancel"
        />
      )}
      <ConfirmationDialog
        show={showDeleteConfirmModal}
        onClose={() => setShowDeleteConfirmModal(false)}
        onCancel={() => setShowDeleteConfirmModal(false)}
        onConfirm={handleDeleteMapping}
        message={`Are you sure you want to remove ${
          selectedMappedItems.length
        } ${modalType === "team" ? "team's" : "user's"} from this challenge?`}
        confirmText="Yes, Remove"
        cancelText="Cancel"
      />
      <HistoryModal
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        params={{ history_uid: historyUid! }}
      />
    </>
  );
};

export default ChallangesPage;

// Styled Components (From challenges2 with added functional components)
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--page-color);
  gap: 16px;
  /* Ensures equal gaps between all child elements */
  padding: 1%;
`;

const ContainerFlex2 = styled.div`
  display: flex;
  justify-content: space-evenly;
  background: var(--card-background);
  width: 97%;
  border-radius: 10px;
  padding: 1% 0;
  button {
    padding: 10px 30px;
    border-radius: 5px;
    border: 1px solid grey;
    background: transparent;
    font-size: 0.875rem;
    cursor: pointer;
    color: var(--text-color);
    transition: all 0.3s ease-in-out;
  }

  .selected {
    background: #094752;
    color: white;
    border-radius: 5px;
  }
`;

const ContainerFlex3 = styled.div`
  display: grid;
  width: 94%;
  background: var(--card-background);
  border-radius: 10px;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 16px;
  .challanges-empty-data-span {
    font-size: 0.875rem;
    color: var(--text-color);
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: var(--card-background);
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 10px;
  aspect-ratio: 16 / 9;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(89, 87, 87, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  color: white;
`;

const OverlayInfo = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const OverlayLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  max-width: 50%;
`;

const OverlayRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  max-width: 80%;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Metric = styled.span`
  display: flex;
  align-items: center;
  background: var(--card-background);
  color: var(--text-color);
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: bold;

  @media (max-width: 1024px) {
    padding: 5px 9px;
    border-radius: 8px;
    font-size: 12px;
  }
  @media (max-width: 900px) {
    padding: 4px 7px;
    border-radius: 5px;
    font-size: 10px;
  }
  @media (max-width: 850px) {
    padding: 3px 5px;
    border-radius: 4px;
    font-size: 8px;
  }
  @media (max-width: 760px) {
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 14px;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  position: relative;

  .challenges-get-dropdown-block {
    position: absolute;
    top: 30px;
    right: 10px;
    background-color: var(--card-background);
    border: 1px solid #ddd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
    width: 100px;
    font-size: 0.875rem;
    font-weight: 400;
    font-family: "Inter", sans-serif;
  }

  .challenges-get-dropdown-option {
    display: flex;
    align-items: center;
    gap: 5%;
    padding: 10px 5px;
    color: black;
    cursor: pointer;
  }

  .challenges-get-dropdown-option:hover {
    background-color: #f5f5f5;
  }

  @media (max-width: 1024px) {
    font-size: 16px;

    .challenges-get-dropdown-block {
      top: 25px;
      right: 8px;
      width: 90px;
      font-size: 0.8125rem;
      border-radius: 3px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    }

    .challenges-get-dropdown-option {
      padding: 8px 4px;
      gap: 4%;
    }
  }

  @media (max-width: 900px) {
    font-size: 12px;

    .challenges-get-dropdown-block {
      top: 22px;
      right: 6px;
      width: 80px;
      font-size: 0.75rem;
      border-radius: 2px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .challenges-get-dropdown-option {
      padding: 6px 3px;
      gap: 3%;
    }
  }

  @media (max-width: 850px) {
    font-size: 10px;

    .challenges-get-dropdown-block {
      top: 20px;
      right: 5px;
      width: 70px;
      font-size: 0.6875rem;
      border-radius: 2px;
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
    }

    .challenges-get-dropdown-option {
      padding: 5px 2px;
      gap: 2%;
    }
  }

  @media (max-width: 760px) {
    font-size: 20px;

    .challenges-get-dropdown-block {
      top: 30px;
      right: 10px;
      width: 100px;
      font-size: 0.875rem;
      border-radius: 4px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .challenges-get-dropdown-option {
      padding: 10px 5px;
      gap: 5%;
    }
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--card-background);
`;

const Title = styled.h2`
  font-size: 1rem;
  color: var(--text-color);
  font-weight: 500;
`;

const Titlename = styled.span`
  font-size: 1.3rem;
  font-weight: 400;
  color: white;
  @media (max-width: 1024px) {
    font-size: 1.15rem;
  }
  @media (max-width: 900px) {
    font-size: 1rem;
  }
  @media (max-width: 850px) {
    font-size: 0.8rem;
  }
  @media (max-width: 760px) {
    font-size: 1.3rem;
  }
`;

const Subtitle = styled.span`
  font-size: 0.875rem;
  color: white;

  @media (max-width: 1024px) {
    font-size: 0.8rem;
  }
  @media (max-width: 900px) {
    font-size: 0.75rem;
  }
  @media (max-width: 850px) {
    font-size: 0.7rem;
  }
  @media (max-width: 760px) {
    font-size: 0.875rem;
  }
`;

const StyledDate = styled.span`
  font-size: 0.875rem;
  color: white;

  @media (max-width: 1024px) {
    font-size: 0.8rem;
  }
  @media (max-width: 900px) {
    font-size: 0.75rem;
  }
  @media (max-width: 850px) {
    font-size: 0.7rem;
  }
  @media (max-width: 760px) {
    font-size: 0.875rem;
  }
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 8px 12px;
  background: var(--card-background);
`;

const JoinedInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15%;
  width: 100%;
  white-space: nowrap;

  @media (max-width: 720px) {
    gap: 7%;
  }
`;

const LeftInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RightInfo = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto; /* This pushes it to the right */
`;

const JoinedText = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  color: red;
  font-weight: bold;
`;

const JoinedText1 = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-color);
  font-weight: bold;
`;

const Badge = styled.div`
  background: #28a745;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  color: white;
  font-weight: bold;

  @media (max-width: 1024px) {
    padding: 3px 5px;
    border-radius: 8px;
    font-size: 8px;
  }
  @media (max-width: 900px) {
    padding: 2px 4px;
    border-radius: 5px;
    font-size: 6px;
  }
  @media (max-width: 850px) {
    padding: 1px 3px;
    border-radius: 3px;
    font-size: 5px;
  }
  @media (max-width: 850px) {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
  }
`;

const ViewToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 1%;
  background: var(--card-background);
  padding: 10px;
  border-radius: 8px;
  width: 94%;
  margin-right: 2%;
  margin-left: 2%;
`;

const ViewToggleButton = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  font-size: 1rem;
  padding: 10px 20px;
  position: relative;
  color: ${(props) =>
    props.active ? "var(--text-color)" : "var(--text-color)"};
  font-weight: ${(props) => (props.active ? "600" : "400")};
  cursor: pointer;
  transition: all 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    bottom: 4px;
    left: 20%;
    width: ${(props) => (props.active ? "60%" : "0")};
    height: 2px;
    background: #094752;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #22a0b7ff;
  }
`;

const JoinButton = styled.button`
  padding: 6px 12px;
  background: #00a86b;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  &:hover {
    background: #007a52;
  }
  @media (max-width: 1024px) {
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 0.8rem;
  }
  @media (max-width: 900px) {
    padding: 2px 5px;
    border-radius: 5px;
    font-size: 0.7rem;
  }
  @media (max-width: 850px) {
    padding: 1px 3px;
    border-radius: 3px;
    font-size: 0.65rem;
  }
  @media (max-width: 760px) {
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 0.875rem;
  }
`;

const StatusTag = styled.div<{ variant?: "warning" | "success" | "info" }>`
  display: inline-block;
  margin-top: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 500;
  width: fit-content;
  background-color: ${(props) =>
    props.variant === "warning"
      ? "#fff3cd"
      : props.variant === "success"
        ? "#d4edda"
        : "#d1ecf1"};
  color: ${(props) =>
    props.variant === "warning"
      ? "#856404"
      : props.variant === "success"
        ? "#155724"
        : "#0c5460"};

  @media (max-width: 1024px) {
    margin-top: 4px;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 400;
  }
  @media (max-width: 900px) {
    fmargin-top: 2px;
    padding: 2px 6px;
    border-radius: 5px;
    font-size: 0.65rem;
    font-weight: 300;
  }
`;

const TeamListContainer = styled.div`
  margin-top: 10px;
`;

const SelectAllRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const TeamCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &.selected {
    border-left: 4px solid #1890ff;
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

const TeamRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const TeamName = styled.span`
  font-weight: 600;
  font-size: 1rem;
`;

const TeamType = styled.span`
  font-size: 0.8rem;
  color: #666;
`;

const TeamCount = styled.span`
  font-size: 0.85rem;
  color: black;
`;

const MemberListContainer = styled.div`
  margin-top: 10px;
`;

const MemberCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;
  &.selected {
    border-left: 4px solid #52c41a;
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

const MemberInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const MemberDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const MemberName = styled.span`
  font-weight: 500;
`;

const AssignTabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
`;

const AssignTabButton = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 10px 0;
  border: none;
  background: none;
  font-size: 1rem;
  font-weight: ${(props) => (props.active ? "600" : "400")};
  color: ${(props) => (props.active ? "#094752" : "#666")};
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  &::after {
    content: "";
    position: absolute;
    bottom: 4px;
    left: 20%;
    width: ${(props) => (props.active ? "60%" : "0")};
    height: 2px;
    background-color: #094752;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #094752;
  }
`;

const VisibilityBadge = styled.div`
  background: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #28a745; /* Green text */
  margin-top: 6px;
  display: inline-block;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 11px;
    margin-top: 5px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 900px) {
    padding: 3px 6px;
    border-radius: 6px;
    font-size: 10px;
    margin-top: 4px;
    font-weight: 500;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 850px) {
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 9px;
    margin-top: 3px;
    font-weight: 500;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.06);
  }

  @media (max-width: 750px) {
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 11px;
    margin-top: 5px;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
`;

const QuitModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const QuitModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

const WarningIcon = styled.div`
  width: 48px;
  height: 48px;
  background: #fff3cd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

const QuitModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
`;

const QuitModalMessage = styled.p`
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 24px;
  font-size: 0.95rem;
`;

const QuitReasonLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
`;

const QuitReasonTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

const QuitModalActions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  justify-content: flex-end;
`;

const CancelButton = styled.button`
  padding: 10px 24px;
  background: #f3f4f6;
  color: #374151;
  border: none;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #e5e7eb;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ConfirmQuitButton = styled.button`
  padding: 10px 24px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #c82333;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const TopBarFilterWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const TopBarFilterBtn = styled.div`
  padding: 10px 14px;
  background: var(--card-background);
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.875rem;
  color: var(--text-color);
  cursor: pointer;
  min-width: 140px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  height: 44px; /* Fixed height */
  box-sizing: border-box;

  span {
    transition: transform 0.2s ease;
    margin-left: 6px;
  }

  .rotate {
    transform: rotate(180deg);
  }

  &:hover {
    border-color: #888;
    background: #f8f9fa;
  }

  /* For smaller screens */
  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    height: 40px;
    padding: 8px 12px;
  }
`;

const TopBarFilterDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  margin-top: 6px;
  z-index: 1001;
  animation: slideDown 0.2s ease;
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  div {
    padding: 12px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
      color: #094752;
      padding-left: 20px;
    }

    &:active {
      background: #efefef;
    }
    .selected-filter {
      background: #e6f4f5;
      color: #094752;
      font-weight: 600;
    }
  }
`;

// Appended Styled Components from Original challenges.txt (needed for functional modals)
const StyledModal = styled(Modal)`
  &.challange-custom-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    border: 1px solid #ccc;
    background: #fff;
    overflow: hidden;
    border-radius: 12px;
    padding: 0 !important;
    .ReactModal__Content {
      display: flex;
      flex-direction: column;
      padding: 20px !important;
      height: 100%;
    }
  }
`;

const ModalOverlayStyled = styled.div`
  &.challange-custom-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 10;

  &:hover {
    background: #f5f5f5;
    color: #333;
  }
`;

const SearchFilterContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
  margin: 16px 0;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  min-width: 0;
`;

const FilterButton = styled.button`
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  min-width: 80px;

  &:hover {
    border-color: #aaa;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const ModalHeader = styled.div`
  flex-shrink: 0;
  margin-bottom: 16px;
  position: relative;
`;

const ModalTitle = styled.h2`
  margin-top: 8px;
  font-size: 1.5rem;
  color: #333;
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  max-height: calc(80vh - 300px);
  margin-bottom: 16px;
`;

const ModalFooter = styled.div`
  flex-shrink: 0;
  border-top: 1px solid #e8e8e8;
  padding-top: 16px;
  margin-top: auto;
`;

const SubmitButton = styled.button<{ disabled: boolean }>`
  width: 100%;
  padding: 12px;
  background: ${(props) => (props.disabled ? "#cccccc" : "#094752")};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: background 0.3s ease;

  &:hover:not(:disabled) {
    background: #07313a;
  }
`;

const RemoveButton = styled.button`
  background: #ff4d4f;
  color: white;
  border: none;
  padding: 6px 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  font-weight: 500;
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  &:hover {
    background: #ff3333;
  }
`;

const DateRangeDisplay = styled.div`
  display: flex;
  align-items: center;
  background: var(--card-background);
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  min-width: 320px;
  flex-shrink: 0;
  height: 44px; /* Fixed height */
  box-sizing: border-box;

  .date-range-text {
    color: var(--text-color);
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    flex: 1;
  }

  @media (max-width: 1024px) {
    min-width: 280px;
    padding: 6px 10px;

    .date-range-text {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
    height: 44px;
    justify-content: center;

    .date-range-text {
      font-size: 0.78rem;
      white-space: normal;
      text-align: center;
      line-height: 1.4;
    }
  }

  @media (max-width: 480px) {
    height: 40px;
    padding: 6px 8px;

    .date-range-text {
      font-size: 0.75rem;
      line-height: 1.3;
    }
  }

  @media (max-width: 360px) {
    .date-range-text {
      font-size: 0.7rem;
    }
  }
`;

// Replace the existing ContainerFlex1 with this:

const ContainerFlex1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 97%;
  gap: 14px;
  // background: var(--card-background);
  padding: 4px;
  border-radius: 10px;
  flex-wrap: wrap;

  .challenges-topbar-search-box {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 0.875rem;
    min-width: 230px;
    border: 1px solid #ddd;
    background-color: var(--card-background);
    border-radius: 10px;
    padding: 10px 14px;
    height: 44px;
    box-sizing: border-box;
  }

  .challenges-search-bar {
    flex: 1;
    border: none;
    outline: none;
    color: var(--text-color);
    height: 100%;
    font-size: 0.875rem;
    background: transparent;
  }

  .challenges-topbar-search-icon {
    margin-right: 8px;
    color: #666;
    font-size: 1.2rem;
  }

  .challenges-new-challange-block {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--card-background);
    white-space: nowrap;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 6px;

    span {
      color: var(--text-color);
      font-size: 0.875rem;
    }

    button {
      padding: 8px 10px;
      border-radius: 6px;
      background: #094752;
      color: #fff;
      font-size: 0.85rem;
      font-weight: 550;
      border: none;
      cursor: pointer;
      transition: background 0.3s ease;

      &:hover {
        background: #07313a;
      }
    }
  }

  /* For smaller screens */
  @media (max-width: 1024px) {
    .challenges-topbar-search-box {
      min-width: 200px;
    }

    .date-range-text {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;

    .challenges-topbar-search-box,
    ${TopBarFilterWrapper},
      ${DateRangeDisplay},
      .challenges-new-challange-block {
      width: 100%;
    }

    ${TopBarFilterWrapper} {
      display: flex;
    }

    ${TopBarFilterBtn} {
      width: 100%;
      justify-content: space-between;
    }

    ${DateRangeDisplay} {
      justify-content: center;

      .date-range-text {
        text-align: center;
      }
    }

    .challenges-new-challange-block {
      justify-content: space-between;
      margin-top: 4px;
    }
  }

  @media (max-width: 480px) {
    .challenges-topbar-search-box,
    ${TopBarFilterBtn},
      ${DateRangeDisplay},
      .challenges-new-challange-block
      button {
      height: 40px;
    }

    ${DateRangeDisplay} {
      .date-range-text {
        font-size: 0.75rem;
      }
    }
  }
`;
